import { View } from "../database-reader/base-database-reader";
import { DB_PROVIDERS } from "../database-reader/configs/db-providers";
const module = {};
class GoogleAdsView extends View {
    setup() {
        this.label = "Google Ads";
        this.model.get("connectionParams").set("type", DB_PROVIDERS.GOOGLEADS.id);
        this.model.set("isCDC", false);
        this.model.set("hasAutoSchemaConversion", window.location.href.indexOf("-to-create-schema") !== -1);
    }
}

module.View = GoogleAdsView;
module.vent = new Backbone.Model();
export default module;
